export function DEBUG(key: string): string {
  return localStorage[`DEBUG_${key}`]
}
